import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LandingDashboard.css';
import axiosInstance from '../utills/axiosInstance';
import CheckinCheckout from '../Attendance/CheckinCheckout'; 
import { useAttendance } from '../Attendance/useAttendance';

const LandingDashboard = () => {
  const navigate = useNavigate();
  const [birthdays, setBirthdays] = useState([]);
  const [newHires, setNewHires] = useState([]);
  const [deptTeams, setDeptTeams] = useState([]);
  const [orgTreeData, setOrgTreeData] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const profile = JSON.parse(localStorage.getItem('profile') || '{}');
  const empId = profile.empId || '';
  const attendance = useAttendance(empId);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const profile = localStorage.getItem('profile');
    if (!token || !profile) {
      localStorage.clear();
       navigate('/', { replace: true });
    }
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);

        const [birthdaysRes, newHiresRes, deptTeamsRes, orgTreeRes, announcementsRes] = await Promise.all([
          axiosInstance.get('/api/birthdays'),
          axiosInstance.get('/api/newhires'),
          axiosInstance.get('/api/teamempcount'),
          axiosInstance.get('/api/emptrees'),
          // axiosInstance.get('/api/announcements'),
        ]);

        setBirthdays(birthdaysRes?.data.data || []);
        setNewHires(newHiresRes?.data.data || []);
        setDeptTeams(deptTeamsRes?.data.data || []);
        setOrgTreeData(orgTreeRes?.data.count || []);
        setAnnouncements(announcementsRes?.data.data || []);
      } catch (err) {
        setError('Failed to load dashboard data. Please try again.');
        console.error('Dashboard fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return <div className="dashboard-container">Loading dashboard...</div>;
  }

  if (error) {
    return <div className="dashboard-container error">{error}</div>;
  }

  return (
    <div className="dashboard-container">
      <h1>Dashboard</h1>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2>Employee Birthdays</h2>
          <p>Upcoming birthdays this month:</p>
          {birthdays?.length > 0 ? (
            <ul>
              {birthdays?.slice(0, 3).map((emp, idx) => (
                <li key={idx}>
                  {emp.firstName} - {emp.department} - {new Date(emp.dateOfBirth).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                </li>
              ))}
            </ul>
          ) : (
            <p>No upcoming birthdays.</p>
          )}
        </div>

        <div className="dashboard-card">
          <h2>New Hires</h2>
          <p>Recent joiners:</p>
          {newHires?.length > 0 ? (
            <ul>
              {newHires?.slice(0, 3).map((emp, idx) => (
                <li key={idx}>
                  {emp.firstName} - {emp.department} - Joined {new Date(emp.dateOfJoining).toLocaleDateString('en-US')}
                </li>
              ))}
            </ul>
          ) : (
            <p>No new hires in the last 30 days.</p>
          )}
        </div>

        <div className="dashboard-card">
          <h2>Attendance</h2>
          <CheckinCheckout
            showTimer={attendance.showTimer}
            elapsedTime={attendance.elapsedTime}
            isBreak={attendance.isBreak}
            formatTime={attendance.formatTime}
            handleCheckin={attendance.handleCheckin}
            handleToggleBreak={attendance.handleToggleBreak}
            handleCheckout={attendance.handleCheckout}
            canCheckin={attendance.canCheckin}
            hasTodayCheckout={attendance.hasTodayCheckout}
          />
        </div>

        <div className="dashboard-card">
          <h2>Department Wise Team Members</h2>
          <p>Team distribution:</p>
          {deptTeams?.length > 0 ? (
            <ul>
              {deptTeams?.slice(0, 3).map((dept, idx) => (
                <li key={idx}>
                  {dept.department}: {dept.count} members
                </li>
              ))}
            </ul>
          ) : (
            <p>No department data available.</p>
          )}
        </div>

        <div className="dashboard-card">
          <h2>Organization Tree</h2>
          <p>View the full hierarchy:</p>
          <div className="org-tree-preview">
            Total Employees: {orgTreeData}
            <br />
            <Link to="/emptree">Open Organization Tree</Link>
          </div>
        </div>

        <div className="dashboard-card">
          <h2>Announcements</h2>
          <p>Latest updates:</p>
          {announcements?.length > 0 ? (
            <ul>
              {announcements.slice(0, 3).map((ann, idx) => (
                <li key={idx}>
                  {ann.title || 'Announcement'} - {new Date(ann.dateOfJoining || ann.createdAt).toLocaleDateString('en-US')}
                </li>
              ))}
            </ul>
          ) : (
            <p>No announcements available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingDashboard;
